import m from "../../geodata/es2015/usaTerritories2High";
window.am4geodata_usaTerritories2High = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/usaTerritories2High.js
// module id = null
// module chunks = 